export const USER_IN_ADMIN_FIELDS = [
    'activeInstitution',
    'admissionOffers',
    'birthdate',
    'city',
    'country',
    'countryInternalTier',
    'deactivated',
    'email',
    'enableFrontRoyalStore',
    'execEdEligibilityBundle',
    'extendExamTime',
    'fallbackProgramType',
    'groups',
    'id',
    'ineligibleForExecEdBundle',
    'institutions',
    'mbaContentLockable',
    'name',
    'nickname',
    'phone',
    'prefLocale',
    'prefUserProgramFieldStateId',
    'programApplications',
    'programFamilyApplications',
    'programFamilyFormData',
    'programInclusions',
    'roles',
    'signableDocuments',
    'signUpCode',
    'state',
    'studentDashboardVersionOverride',
    'studentId',
    'timezone',
    'tuitionContracts',
    'refundEntitlements',
    'userIdVerifications',
    'userProgramFieldStates',
    'userProgramStates',
    'zip',
    'coachSessionOpportunities',
] as const;
